module.exports = function(service) {
	'use strict'
	service.service('warningAlertService',warningAlertService);
	warningAlertService.$inject=['$rootScope','$timeout'];
	function warningAlertService($rootScope,$timeout) {
		return function(title,message,warningCallback,warningCallbackCancel) {
			$rootScope.warningAlert = {
                title:title,
                message:message,
                warningCallback: warningCallback,
                warningCallbackCancel: warningCallbackCancel,
                show: true,
                closeAlert: function(type) {
                    this.show= false
                    if(type !== 'confirm' && this.warningCallbackCancel) this.warningCallbackCancel();
                }
            }
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/warningAlertService.js
// module id = 630
// module chunks = 0